import { createContext, useContext } from 'react';

export type NoticeKind = 'info' | 'error';

export interface Notice {
  kind: NoticeKind;
  message: string;
  details?: string[];
}

export interface NoticesApi {
  info: (message: string, details?: string[]) => void;
  error: (message: string, details?: string[]) => void;
}

export const NoticesContext = createContext<NoticesApi | null>(null);

export function useNotices(): NoticesApi {
  const api = useContext(NoticesContext);
  if (!api) throw new Error('useNotices requiere NoticesProvider.');
  return api;
}
